export enum CasePageEnum {
    Overview = "overview",
    RequiremenstTable = "requirementstable",
    Radar = "radar",
    Intake = "intake"
}